import { FC, PropsWithChildren, useCallback, useMemo } from "react"
import { Form, Input, DatePicker, Button, Select } from 'antd'
import moment from 'moment'
import BlockComplex from '@/components/BlockComplex'
import boicon from '@/assets/images/workbench/bo.png'
import * as api from '@/api/workbench'
import { approveModelOptions } from '@/utils/options'

type PropType = FC<PropsWithChildren<{
  type: string
  onFlushCount?: (params: any) => void
}>>

const Comp: PropType = ({ type, onFlushCount }) => {
  const defaultDate = useMemo(() => {
    if(type === '已审核') {
      return [moment(), moment()]
    }
    return []
  }, [type])

  const handleApprove = useCallback((row) => {
    window.openInnerPage(row.URL, row.MKMC)
  }, [])

  const columns = useMemo(() => {
    const cols: any[] = [
      { title: '审核操作', width: 100, dataIndex: 'SHCZ', ellipsis: true },
      {
        title: '单据编号', 
        width: 150, 
        dataIndex: 'DJBH',
        ellipsis: true,
        render(text, record) {
          return (
            <div>
              {
                record.BHZT === 'Y' && <img src={boicon} alt="" className="mr-4" />
              }
              <span className="vertical-middle">{text}</span>
            </div>
          )
        }
      },
      { title: '类型', width: 80, dataIndex: 'XTDL', ellipsis: true },
      { title: '模块名', width: 150, dataIndex: 'MKMC', ellipsis: true },
      { title: '项目名称', width: 150, dataIndex: 'XMMC', ellipsis: true },
      { title: '单据金额（元）', width: 120, dataIndex: 'DJJE', ellipsis: true },
      { title: '申请人', width: 80, dataIndex: 'SQR', ellipsis: true },
      { title: '申请部门', width: 80, dataIndex: 'SQRBM', ellipsis: true },
      { title: '申请时间', width: 110, dataIndex: 'SQSJ', ellipsis: true },
      { title: '时长', width: 80, dataIndex: 'SC', ellipsis: true },
      { title: '待审时间', width: 110, dataIndex: 'DSSJ', ellipsis: true },
    ]
    if(type === '待审核') {
      cols.push({
        title: '操作', 
        width: 60, 
        dataIndex: 'cz', 
        render(text, record) {
          return <Button type="link" onClick={() => handleApprove(record)}>审核</Button>
        }
      })
    }
    return cols
  }, [type, handleApprove])

  const query = useCallback(async (params) => {
    const request = type === '待审核' ? api.getWdspDsh : api.getWdspYsh
    const rq: any = {}
    if(params.rq && params.rq.length > 0) {
      rq.ksrq = params.rq[0].format('YYYY-MM-DD 00:00:00')
      rq.jsrq = params.rq[1].format('YYYY-MM-DD 23:59:59')
    }
    if(onFlushCount) {
      onFlushCount({
        ...params,
        ...rq,
        rq: undefined
      })
    }
    const res = await request({
      ...params,
      ...rq,
      rq: undefined
    })
    return {
      status: res.success,
      data: res.data.map(r => ({
        ...r,
        DSSJ: r.DSSJ ? moment(r.DSSJ).format('YYYY-MM-DD') : '',
        SQSJ: r.SQSJ ? moment(r.SQSJ).format('YYYY-MM-DD') : '',
      })),
      total: res.data.length
    }
  }, [type])

  return (
    <div className="">
      <BlockComplex
        columns={columns}
        rowKey="DJBH"
        load={query}
        searchForm={
          <>
            <Form.Item
              label="单据编号"
              name="djbh"
            >
              <Input placeholder="请输入" />
            </Form.Item>
            <Form.Item
              label="模块名"
              name="mkm"
            >
              <Select placeholder="请选择">
                {
                  approveModelOptions.map(item => <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>)
                }
              </Select>
            </Form.Item>
            <Form.Item
              label="日期"
              name="rq"
              initialValue={defaultDate}
            >
              <DatePicker.RangePicker />
            </Form.Item>
          </>
        }
      />
    </div>
  )
}

export default Comp
